"use client";

import {CircleAlert, CircleCheck, CircleX, Info} from "lucide-react";
import {Toaster as Sonner} from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({...props}: ToasterProps) => {
  return (
    <Sonner
      theme={props.theme}
      className="toaster group"
      icons={{
        success: <CircleCheck className="text-green-700" size="16px" />,
        error: <CircleX className="text-red-700" size="16px" />,
        warning: <CircleAlert className="text-yellow-700" size="16px" />,
        info: <Info className="text-blue-700" size="16px" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group flex justify-between toast border group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          content: "flex-auto",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "right-0 group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        },
      }}
      {...props}
    />
  );
};

export {Toaster};
